<template>
  <div>
    <gridTable style="padding: 12px 0" :columns="baseInfoColumns" :data-list="info.baseDataList"></gridTable>
    <div v-for="(item,index) in otherInfo">
      <gridTable style="padding-bottom: 12px" :columns="otherInfoColumns" :data-list="item.otherDataList"></gridTable>
      <gridTable v-if="index+1 === otherInfo.length" style="padding-bottom: 12px" :columns="item.totalDataList" :data-list="[]"></gridTable>
    </div>
  </div>
</template>

<script>
  import gridTable from "@/pages/components/Print/modules/M60-print/common/grid-table";

  const activeBGColor = {
    background: 'rgba(255,255,128,.5) !important',
  }
  export default {
    name: "print-content",
    components: {
      gridTable
    },
    props: {
      info: {
        type: Object,
        default: () => {
        }
      },
      otherInfo: {
        type: Array,
        default: () => []
      },

    },
    data() {
      return {
        baseInfoColumns: [
          {
            "label": "SUPPLIER",
            "property": "vendorCode",
            style: activeBGColor
          }, {
            "label": "ORDER NO",
            "property": "sapPoNo",
            style: activeBGColor
          }, {
            "label": "YEAR-SEASON",
            "property": "fixedText",
            style: activeBGColor
          }, {
            "label": "ORDER TYPOLOGY",
            "property": "poTypeDesc",
            style: activeBGColor
          }, {
            "label": "Destination",
            "property": "poArea",
            style: activeBGColor
          }
        ],
        otherInfoColumns: [
          {
            "label": "Order date",
            "property": "createdDate",
            style: activeBGColor
          }, {
            "label": "Item",
            "property": "poItemCode",
            style: activeBGColor
          }, {
            "label": "Colour",
            "property": "colorCode",
            style: activeBGColor
          }, {
            "label": "Description",
            style: activeBGColor
          }, {
            "label": "Line",
            style: activeBGColor
          }, {
            "label": "Fml",
            style: activeBGColor
          }, {
            "label": "Style",
            style: activeBGColor
          }, {
            "label": "Fabric",
            style: activeBGColor
          }, {
            "label": "Wash",
            style: activeBGColor
          }, {
            "label": "Year",
            style: activeBGColor
          }, {
            "label": "Season",
            style: activeBGColor
          }, {
            "label": "Delivery Required",
            "property": "deliveryDate",
            style: activeBGColor
          }, {
            "label": "Currency",
            "property": "currency",
            style: activeBGColor
          }, {
            "label": "Unit Price",
            "property": "price",
            style: activeBGColor
          }],
        totalInfoColumns: [{
          "label": "FINAL TOTAL",
          "property": "",
        }, {
          "label": "108",
          "property": "",
        }, {
          "label": "3132.00",
          "property": "",
        },]
      }
    },
    computed: {}
  }
</script>

<style scoped lang="scss">

</style>